<template lang="html">

    <div class="cover-popup row-center" v-if="show && $route.name != 'rgpd'">
        <div class="popup">
            <a class="close" v-if="showClose" @click="hideEncuestas">✕</a>
            <h2 class="title-pop">Encuestas ESIC</h2>
            <p>Tienes cuestionarios pendientes de completar. Por favor, accede ahora para contestar.</p>
            <p>¡Valoramos tu opinión!</p>

            <div class="encuesta-el row-between" v-for="encuesta in encuestas">
                <h4>{{encuesta.titulo}}</h4>
                <a class="btn" :href="encuesta.urlAcceso" target="_blank">Ir a la encuesta</a>
            </div>


            <p><i>Debes contestar los cuestionarios marcados con asterisco (*) para seguir usando el portal.</i></p>
        </div>
    </div>

</template>

<script lang="js">
    
    import {mapGetters,mapActions} from 'vuex';

    export default {
        name: 'popup-encuestas',
        methods :{
            ...mapActions(['hideEncuestas'])
        },
        computed:{
            ...mapGetters({
                show : 'getShowEncuestas',
                encuestas : 'getEncuestas'
            }),
            showClose(){
                let show = true;

                if(!!this.encuestas){
                    show = !this.encuestas.some(e => e.respuestaObligatoria);
                }

                return show;
            }
        }
    }
</script>

<style scoped lang="scss">
    p {
        margin-bottom: 10px;
        &:last-of-type {
            margin-bottom: 0;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-encuestas.vue